//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import menuMixin from '../mixin/menu'
import aside from '@/index/menu/aside.js'
import d2LayoutMainMenuItem from '../components/menu-item/index.vue'
import d2LayoutMainMenuSub from '../components/menu-sub/index.vue'
import BScroll from 'better-scroll'
export default {
  name: 'd2-layout-header-aside-menu-side',
  mixins: [
    menuMixin
  ],
  data () {
    return {
      active: '',
      asideHeight: 300,
      BS: null
    }
  },
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem,
    'd2-layout-header-aside-menu-sub': d2LayoutMainMenuSub
  },
  computed: {
    ...mapState({
      menuAside: state => state.d2admin.menuAside,
      isMenuAsideCollapse: state => state.d2admin.isMenuAsideCollapse
    })
  },
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    isMenuAsideCollapse (val) {
      // this.scrollDestroy()
      // setTimeout(() => {
      //   this.scrollInit()
      // }, 500)
    },
    // 监听路由 控制侧边栏激活状态
    '$route.matched': {
      handler (val) {
        // console.log('$route.matched', val)
        let getTitle = () => {
          for (let i = val.length-1; i > -1; i--) {
            let meta = val[i].meta
            // console.log('meta', meta)
            // console.log('meta.title', meta.title)
            if (meta && meta.title) {
              return meta.title
            }
          }
        }
        let title = getTitle()
        let getPath = () => {
          if (title) {
            for (let i = 0; i < aside.length; i++) {
              // console.log('aside[i].title', aside[i].title)
              if (aside[i].title === title) {
                return aside[i].path
              } else {
                // console.log('aside[i].children', aside[i].children)
                if (aside[i].children) {
                  for (let j = 0; j < aside[i].children.length; j++) {
                    // console.log('aside[i].children[j].title', aside[i].children[j].title)
                    if (aside[i].children[j].title === title) {
                      return aside[i].children[j].path
                    }
                  }
                }
              }
            }
          }
        }
        // this.active = val[val.length - 1].path
        this.active = getPath()
        // console.log('title', title)
        // console.log('val', val[val.length - 1])
        // console.log('active', this.active)
        this.$nextTick(() => {
          if (this.menuAside.length > 0 && this.$refs.menu) {
            this.$refs.menu.activeIndex = this.active
          }
        })
      },
      immediate: true
    }
  },
  mounted () {
    // this.scrollInit()
  },
  beforeDestroy () {
    // this.scrollDestroy()
  },
  methods: {
    scrollInit () {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true
        // 如果你愿意可以打开显示滚动条
        // scrollbar: {
        //   fade: true,
        //   interactive: false
        // }
      })
    },
    scrollDestroy () {
      if (this.BS) {
        this.BS.destroy()
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
